import styled from "styled-components"

const NameImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  b {
    font-family: var(--font-sans-serif);
  }
  /* margin-bottom: 0.5em; */
  img {
    width: 100%;
    max-width: 200px;
    max-height: 200px;
    object-fit: cover;
    margin: 0;
    border-radius: 50%;
    /* margin-bottom: 0.5em; */
  }
`
export default NameImage